import   React, 
       { useState, 
         useEffect, 
         useRef,
         useMemo                      }     from "react";
import * as WebDataRocksReact               from "@webdatarocks/react-webdatarocks";
import { useModal                     }     from "components/Covers/genericModal";
import { GetAppLang,
         GetLabel,                    }     from "Utilities/utils";
import { InputGeneral                 }     from "components/Field/field";
import  MainStyle                           from "components/UI/main.module.scss";
import                                           "@webdatarocks/webdatarocks/webdatarocks.css";
import { DisplayDateAsString          }     from "components/Date/date";

let appLang              = GetAppLang();
const cdn_lang_map       = {
    PT: "https://cdn.webdatarocks.com/loc/pr.json",
    EN: "https://cdn.webdatarocks.com/loc/en.json",
    ES: "https://cdn.webdatarocks.com/loc/es.json",
};

const GlobeSVG = () => {
    return (    
            <svg className={MainStyle.ico_svg_info} viewBox="0 0 24 24">                
                <path d="M8,13H2a10,10,0,0,0,10,9C9.44,22,8.18,17.51,8,13Z"/>
                <path d="M2,11H8c.16-4.51,1.42-9,4-9A10,10,0,0,0,2,11Z"/>
                <path d="M12,20c.48,0,1.81-2.4,2-7H10C10.19,17.6,11.52,20,12,20Z"/>
                <path d="M12,4c-.48,0-1.81,2.4-2,7h4C13.81,6.4,12.48,4,12,4Z"/>
                <path d="M12,22a10,10,0,0,0,10-9H16C15.82,17.51,14.56,22,12,22Z"/>
                <path d="M12,2c2.56,0,3.82,4.49,4,9h6A10,10,0,0,0,12,2Z"/>
            </svg>
    );
};

function normalizeString(str) {
    if (!str) return "";

    var s = str;

    // remove accents
    s = s.normalize("NFD");
    s = s.replace(/[\u0300-\u036f]/g, "");

    // collapse multiple spaces
    s = s.replace(/\s+/g, " ");

    // trim
    s = s.trim();

    // lowercase
    s = s.toLowerCase();

    return s;
}

const PublicSelection = React.memo(({...props}) => {
    const { configData, 
            filterDataList,
            UseItem,
            CopyItem                     }   = props;
    const [searchString, setSearchString ]   = useState("");
    const [filteredData, setFilteredData ]   = useState([]);

    useEffect(() => {},[filterDataList]);

    const handleSearchData = (value) => {
        setSearchString(value);

        if (!filterDataList || !filterDataList.PUBLIC) return;

        const search = normalizeString(value);

        if (search === "") {
            setFilteredData({
                ...filterDataList,
                PUBLIC: filterDataList.PUBLIC
            });
            return;
        }

        const temp_arr = filterDataList.PUBLIC.filter((item) => {

            const text = normalizeString(item?.TEMPLATE_PUBLIC_DESC) + " " + normalizeString(item?.AUTHOR_FULL_NAME);
            return text.indexOf(search) !== -1;
        });

        setFilteredData({
            ...filterDataList,
            PUBLIC: temp_arr
        });
    };
    
    return (
        <React.Fragment>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <InputGeneral 
                        value={searchString}
                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                        onChange={(event) => handleSearchData(event.target.value)}
                        placeholder={GetLabel(appLang, 33)}
                        maxLength={500}
                    />
                </div>
            </div>
            <div className={MainStyle.overflow_y_scroll} style={{height: '20rem'}}>                        
                {  filteredData?.PUBLIC !== configData?.PUBLIC ?
                    
                    filteredData?.PUBLIC?.length === 0 ?
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_12}>
                                <p className={[  MainStyle.fs_7,
                                                    MainStyle.text_body_faded,
                                                    MainStyle.fw_semibold,
                                                    MainStyle.mt_3,
                                                    MainStyle.text_center
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 220)}
                                </p>
                            </div>
                        </div>
                    :
                    filteredData?.PUBLIC?.map((data) => {
                        return (
                            <div key={data.TEMPLATE_ID} className={[MainStyle.row, MainStyle.align_items_center, MainStyle.py_2].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <p className={[MainStyle.text_body, MainStyle.fs_9].join(" ")}>{GetLabel(appLang, 366)}:</p>
                                    <p className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>{data?.TEMPLATE_PUBLIC_DESC}</p>
                                </div>    
                                <div className={MainStyle.col}>
                                    <p className={[MainStyle.text_body, MainStyle.fs_9].join(" ")}>Autor:</p>
                                    <p className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>{data?.AUTHOR_FULL_NAME}</p>
                                </div>
                                <div className={MainStyle.col_3}>
                                    <p className={[MainStyle.text_body, MainStyle.fs_9].join(" ")}>Atualizado em:</p>
                                    <p className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>{DisplayDateAsString(data?.UPDATED, true)}</p>
                                </div>                                                                      
                                {[
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <CopyItem props={data}      /></div>   , id: 'copy' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <UseItem props={data}       /></div>   , id: 'use' }
                                ].map((item) => (
                                    <div 
                                        key={item.id} 
                                        className={MainStyle.col} 
                                        style={{ 
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center",
                                            padding: 0,
                                            margin: 0,
                                        }}
                                    >
                                        <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")} style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item.content}
                                        </div>
                                    </div>
                                ))}                                                                                                                                                                                                            
                            </div>
                        );
                    })
                :
                    filterDataList?.PUBLIC?.length > 0 ?
                    filterDataList?.PUBLIC?.map((data) => {
                        return (
                            <div key={data.TEMPLATE_ID} className={[MainStyle.row, MainStyle.align_items_center, MainStyle.py_2].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <p className={[MainStyle.text_body, MainStyle.fs_9].join(" ")}>{GetLabel(appLang, 366)}:</p>
                                    <p className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>{data?.TEMPLATE_PUBLIC_DESC}</p>
                                </div>    
                                <div className={MainStyle.col}>
                                    <p className={[MainStyle.text_body, MainStyle.fs_9].join(" ")}>Autor:</p>
                                    <p className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>{data?.AUTHOR_FULL_NAME}</p>
                                </div>
                                <div className={MainStyle.col_3}>
                                    <p className={[MainStyle.text_body, MainStyle.fs_9].join(" ")}>Atualizado em:</p>
                                    <p className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>{DisplayDateAsString(data?.UPDATED, true)}</p>
                                </div>                                                                      
                                {[
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <CopyItem props={data}      /></div>   , id: 'copy' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <UseItem props={data}       /></div>   , id: 'use' }
                                ].map((item) => (
                                    <div 
                                        key={item.id} 
                                        className={MainStyle.col} 
                                        style={{ 
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center",
                                            padding: 0,
                                            margin: 0,
                                        }}
                                    >
                                        <div style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item.content}
                                        </div>
                                    </div>
                                ))}                                                                                                                                                                                                            
                            </div>
                        );
                    })
                    :
                    null
                }
            </div>
        </React.Fragment>
    );
});

const PersonalSelection = React.memo(({...props}) => {
    const { configData, 
            filterDataList,
            UseItem,
            CopyItem,
            EditItem,
            DeleteItem                   }   = props;
    const [searchString, setSearchString ]   = useState("");
    const [filteredData, setFilteredData ]   = useState(null);

    useEffect(() => {},[filterDataList]);

    const handleSearchData = (value) => {
        setSearchString(value);

        if (!filterDataList || !filterDataList.PERSONAL) return;

        const search = normalizeString(value);

        if (search === "") {
            setFilteredData({
                ...filterDataList,
                PERSONAL: filterDataList.PERSONAL
            });
            return;
        }

        const words     = search.split(" ");
        const temp_arr  = filterDataList.PERSONAL.filter((item) => {
            const text = normalizeString(item?.TEMPLATE_DESC);
            for (let i = 0; i < words.length; i++) {
                if (text.indexOf(words[i]) === -1) {
                    return false;
                }
            }
            return true;
        });

        setFilteredData({
            ...filterDataList,
            PERSONAL: temp_arr
        });
    };
    return (
        <React.Fragment>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <InputGeneral 
                        value={searchString}
                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                        onChange={(event) => handleSearchData(event.target.value)}
                        placeholder={GetLabel(appLang, 33)}
                        maxLength={500}
                    />
                </div>
            </div>
            <div className={MainStyle.overflow_y_scroll} style={{height: '20rem'}}>                        
                {  filteredData?.PERSONAL !== configData?.PERSONAL ?
                    
                    filteredData?.PERSONAL?.length === 0 ?
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_12}>
                                <p className={[  MainStyle.fs_7,
                                                    MainStyle.text_body_faded,
                                                    MainStyle.fw_semibold,
                                                    MainStyle.mt_3,
                                                    MainStyle.text_center
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 220)}
                                </p>
                            </div>
                        </div>
                    :
                    filteredData?.PERSONAL?.map((data) => {
                        return (
                            <div key={data.TEMPLATE_ID} className={[MainStyle.row, MainStyle.align_items_center, MainStyle.py_2].join(" ")}>
    
                                <div className={MainStyle.col_7}>
                                    <span className={[MainStyle.text_body, MainStyle.fs_8, MainStyle.m_0].join(" ")}>
                                        {data?.TEMPLATE_DESC}
                                    </span>
                                </div>
                                {[
                                    { content: data?.PUBLISHED === 1 ?  <GlobeSVG /> : null           , id: 'pub' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <DeleteItem props={data}    /></div>   , id: 'del' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <CopyItem props={data}      /></div>   , id: 'copy' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <EditItem props={data}      /></div>   , id: 'edit' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <UseItem props={data}       /></div>   , id: 'use' }
                                ].map((item) => (
                                    <div 
                                        key={item.id} 
                                        className={MainStyle.col} 
                                        style={{ 
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center",
                                            padding: 0,
                                            margin: 0,
                                        }}
                                    >
                                        <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")} style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item.content}
                                        </div>
                                    </div>
                                ))}                                                                                                                                                                                                            
                            </div>
                        );
                    })
                :
                    filterDataList?.PERSONAL?.length > 0 ?
                    filterDataList?.PERSONAL?.map((data) => {
                        return (
                            <div key={data.TEMPLATE_ID} className={[MainStyle.row, MainStyle.align_items_center, MainStyle.py_2].join(" ")}>
    
                                <div className={MainStyle.col_7}>
                                    <span className={[MainStyle.text_body, MainStyle.fs_8, MainStyle.m_0].join(" ")}>
                                        {data?.TEMPLATE_DESC}
                                    </span>
                                </div>
                                {[
                                    { content: data?.PUBLISHED === 1 ?  <GlobeSVG /> : null           , id: 'pub' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <DeleteItem props={data}    /></div>   , id: 'del' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <CopyItem props={data}      /></div>   , id: 'copy' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <EditItem props={data}      /></div>   , id: 'edit' },
                                    { content: <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")}> <UseItem props={data}       /></div>   , id: 'use' }
                                ].map((item) => (
                                    <div 
                                        key={item.id} 
                                        className={MainStyle.col} 
                                        style={{ 
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center",
                                            padding: 0,
                                            margin: 0,
                                        }}
                                    >
                                        <div style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item.content}
                                        </div>
                                    </div>
                                ))}                                                                                                                                                                                                            
                            </div>
                        );
                    })
                    :
                    null
                }
            </div>
        </React.Fragment>
    );
});

const TemplateEdit = React.memo(({...props}) => {
    const { extractConfigData,
            setConfigData,
            filterObj,
            setFilterObj,
            actionUpdateFilter,
            hideModal                       }   = props;
    const [ innerObj,           setInnerObj ]   = useState(filterObj);

    const handleChange = (updatedField) => {
        setInnerObj((prev) => ({
            ...prev,
            ...updatedField
        }));
    };

    const handleSave = async () => {
        if ((innerObj?.TEMPLATE_DESC?.length === 0) || (innerObj?.PUBLISHED === 1 && innerObj?.TEMPLATE_PUBLIC_DESC?.length === 0)) {
            return;
        }
        const configuration = await extractConfigData();
        const targetData = {
                TEMPLATE_ID: innerObj.TEMPLATE_ID,
                TEMPLATE_DESC: innerObj.TEMPLATE_DESC,
                TEMPLATE_PUBLIC_DESC: innerObj.TEMPLATE_PUBLIC_DESC,
                TEMPLATE_DATA: {
                    PT: configuration,
                    EN: configuration,
                    ES: configuration,
                },
                PUBLISHED: innerObj.PUBLISHED,
        };  
        actionUpdateFilter(targetData);
        setConfigData(targetData.TEMPLATE_DATA);
        setFilterObj(targetData);
        hideModal();
    };

    useEffect(() => {
        setInnerObj(filterObj);
    },[filterObj]);

    return(
        <>
            <div className={MainStyle.py_2}/>
            {/*     Description      */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_3}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.justify_content_center, MainStyle.mx_3].join(" ")}>
                            <p className={[MainStyle.fs_7,
                                            MainStyle.text_body,
                                            MainStyle.fw_semibold
                                            ].join(" ")}
                            >
                                {GetLabel(appLang, 366)}:
                            </p>                            
                            {(innerObj?.TEMPLATE_DESC?.length === 0) && (
                                    <p className={[MainStyle.fs_10, MainStyle.text_danger].join(" ")}>
                                        {GetLabel(appLang, 566)}
                                    </p>
                            )}                            
                    </div>
                </div>
                <div className={MainStyle.col_lg}>
                    <div className={MainStyle.mx_3}>
                        <InputGeneral 
                            value={innerObj?.TEMPLATE_DESC}
                            className={[MainStyle.fs_7, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                            onChange={(event) => handleChange({ TEMPLATE_DESC: event.target.value })}
                            placeholder={GetLabel(appLang, 366)}
                            maxLength={50}
                        />
                        <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>
                            {innerObj?.TEMPLATE_DESC?.length} {GetLabel(appLang, 44)} 50 {GetLabel(appLang, 45)}.
                        </span>
                    </div>
                </div>
            </div>
            <div className={MainStyle.py_2}/>
            {/*  Public Description  */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_3}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.justify_content_center, MainStyle.mx_3].join(" ")}>
                        <p className={[MainStyle.fs_7,
                                        MainStyle.text_body,
                                        MainStyle.fw_semibold
                                        ].join(" ")}
                        >
                            {GetLabel(appLang, 612)}:
                        </p>
                        {(innerObj?.PUBLISHED === 1 && innerObj?.TEMPLATE_PUBLIC_DESC?.length === 0) && (
                                <p className={[MainStyle.fs_10, MainStyle.text_danger].join(" ")}>
                                    {GetLabel(appLang, 566)}
                                </p>
                        )}
                    </div>
                </div>
                <div className={MainStyle.col_lg}>
                    <div className={MainStyle.mx_3}>
                        <InputGeneral 
                            value={innerObj?.TEMPLATE_PUBLIC_DESC}
                            className={[MainStyle.fs_7, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                            onChange={(event) => handleChange({ TEMPLATE_PUBLIC_DESC: event.target.value })}
                            placeholder={GetLabel(appLang, 612)}
                            maxLength={50}
                        />
                        <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>
                            {innerObj?.TEMPLATE_PUBLIC_DESC?.length} {GetLabel(appLang, 44)} 50 {GetLabel(appLang, 45)}.
                        </span>
                    </div>
                </div>
            </div>
            <div className={MainStyle.py_2}/>
            {/*   Public Access      */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_3}>
                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                        <span className={[MainStyle.fs_7,
                                        MainStyle.text_body,
                                        MainStyle.fw_semibold
                                        ].join(" ")}
                        >
                            {GetLabel(appLang, 615)}:
                        </span>
                    </div>
                </div>
                <div className={MainStyle.col_lg_9}>
                    <div className={MainStyle.mx_3}>
                        <input
                            type="checkbox"
                            name={"read"}
                            checked={innerObj?.PUBLISHED === 1 ? true : false}
                            onChange={()=> {innerObj?.PUBLISHED  === 0 ? handleChange({ PUBLISHED: 1 }) : handleChange({ PUBLISHED: 0 })}}
                            style={{ transform: "scale(1.5)" }}
                            disabled={false}
                        />
                    </div>
                </div>
            </div>   
            <div className={MainStyle.py_2}/>         
            {/*   Save Changes      */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col}/>
                <div className={MainStyle.col_3}>
                    <div className={[MainStyle.btn_vanilla,
                                    MainStyle.rounded_3, 
                                    MainStyle.border, 
                                    MainStyle.shadow_sm, 
                                    MainStyle.fs_8,
                                    MainStyle.p_1,
                                    MainStyle.text_center,
                                    MainStyle.mx_3].join(" ")}
                        onClick={() => {handleSave();}}
                    >
                        <span>{GetLabel(appLang, 49)}</span>
                    </div>
                </div>
            </div>
            <div className={MainStyle.py_2}/>                             

        </>
    );
});

const TemplateSelection = React.memo(({...props}) => {
    const { extractConfigData,
            configData,
            setConfigData,
            filterObj,
            setFilterObj,
            filterDataList,
            refreshControl,
            actionUpdateFilter,
            actionDeleteFilter,          }   = props;
    const [searchString, setSearchString ]   = useState("");
    const [filteredData, setFilteredData ]   = useState([]);
    const [listType,     setListType     ]   = useState(1);
    const { showModal, hideModal         }   = useModal();

    const CopyItem = ({props}) => {
        const handleData = () => {
            console.log(props);
            const isPublic = !Object.hasOwn(props, "PUBLISHED");
            const targetData = {
                TEMPLATE_ID: 0,
                TEMPLATE_DESC: isPublic
                    ? `Copiado de ${props.TEMPLATE_PUBLIC_DESC}`
                    : `Copiado de ${props.TEMPLATE_DESC}`,
                TEMPLATE_PUBLIC_DESC: "",
                TEMPLATE_DATA: JSON.parse(props.TEMPLATE_DATA),
                PUBLISHED: 0,
            };
            setFilterObj(targetData);
            hideModal();
            showModal(
                <TemplateEdit
                    extractConfigData={extractConfigData}
                    configData={configData}
                    setConfigData={setConfigData}
                    filterObj={targetData}
                    setFilterObj={setFilterObj}
                    filterDataList={filterDataList}
                    refreshControl={refreshControl}
                    actionUpdateFilter={actionUpdateFilter}
                    actionDeleteFilter={actionDeleteFilter}
                    hideModal={hideModal}
                />
            );
        };
        return(
            <div onClick={handleData}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 448 512"
                    className={[MainStyle.small_ico_generic].join(" ")}
                >
                    <path d="M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"/>
                </svg>
            </div>
        );
    };

    const EditItem = ({props}) => {
        const handleData = () => {
            const targetData = {
                TEMPLATE_ID: props.TEMPLATE_ID,
                TEMPLATE_DESC: props.TEMPLATE_DESC,
                TEMPLATE_PUBLIC_DESC: props.TEMPLATE_PUBLIC_DESC,
                TEMPLATE_DATA: JSON.parse(props.TEMPLATE_DATA),
                PUBLISHED: props.PUBLISHED,
            };
            setFilterObj(targetData);
            hideModal();
            showModal(
                    <TemplateEdit
                        extractConfigData={extractConfigData}
                        configData={configData}
                        setConfigData={setConfigData}
                        filterObj={targetData}
                        setFilterObj={setFilterObj}
                        filterDataList={filterDataList}
                        refreshControl={refreshControl}
                        actionUpdateFilter={actionUpdateFilter}
                        actionDeleteFilter={actionDeleteFilter}
                        hideModal={hideModal}
                    />
            );
        };
        return (
            <div onClick={handleData}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 512 512"
                    className={[MainStyle.small_ico_generic].join(" ")}
                >
                    <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                </svg>
            </div>
        );
    };
    
    const UseItem = ({props}) => {
        const handleData = () => {
            if (!props || !props.TEMPLATE_DATA) return;

            try {
                const isPublic = !Object.hasOwn(props, "PUBLISHED");
                const targetData = {
                    TEMPLATE_ID: isPublic
                        ? 0
                        : props.TEMPLATE_ID,
                    TEMPLATE_DESC: isPublic
                        ? props.TEMPLATE_PUBLIC_DESC
                        : props.TEMPLATE_DESC,
                    TEMPLATE_PUBLIC_DESC:  isPublic
                        ? ""
                        : props.TEMPLATE_PUBLIC_DESC,
                    TEMPLATE_DATA: JSON.parse(props.TEMPLATE_DATA),
                    PUBLISHED: isPublic
                        ? 0
                        : props.PUBLISHED,
                };
                setConfigData(targetData.TEMPLATE_DATA);
                setFilterObj(targetData);
                hideModal();
            } 
            catch (error) {
                console.error(error);
            }
        };
        return (
            <div onClick={handleData}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"  
                    viewBox="0 0 512 512"
                    className={[MainStyle.small_ico_generic].join(" ")}
            >
                    <path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                </svg>
            </div>
        );
    };

    const DeleteItem = ({props}) => {
        const handleData = () => {
            actionDeleteFilter(props);
            hideModal();
            const targetData = {
                TEMPLATE_ID: 0,
                TEMPLATE_DESC: "",
                TEMPLATE_PUBLIC_DESC: "",
                TEMPLATE_DATA: "",
                PUBLISHED: 0,
            }
            setFilterObj(targetData);
        };
    
        return(
            <div onClick={handleData}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 448 512"
                    className={[MainStyle.small_ico_generic].join(" ")}
                >
                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                </svg>
            </div>
        );
    };
    
    useEffect(() => {},[filterObj, filterDataList]);

    return (
        <div className={[MainStyle.mx_3].join(" ")}>
            <span className={[MainStyle.text_body, MainStyle.fs_6].join(" ")}>{GetLabel(appLang, 616)}: </span>
            {listType === 1 && (
                <span className={[MainStyle.text_body, MainStyle.fs_6].join(" ")}>{GetLabel(appLang, 617)}</span>
            )}
            {listType === 2 && (
                <span className={[MainStyle.text_body, MainStyle.fs_6].join(" ")}>{GetLabel(appLang, 619)}</span>
            )}            
            <div className={MainStyle.py_2}/>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_5}>
                    <div className={[MainStyle.btn_vanilla,
                                    MainStyle.rounded_3, 
                                    MainStyle.border, 
                                    MainStyle.shadow_sm, 
                                    MainStyle.fs_8,
                                    MainStyle.p_1,
                                    MainStyle.text_center].join(" ")}
                         onClick={() => {setListType(1);}}
                    >
                        <span>{GetLabel(appLang, 618)}</span>
                    </div>
                </div>
                <div className={MainStyle.col}/>
                <div className={MainStyle.col_5}>
                    <div className={[MainStyle.btn_vanilla,
                                    MainStyle.rounded_3, 
                                    MainStyle.border, 
                                    MainStyle.shadow_sm, 
                                    MainStyle.fs_8,
                                    MainStyle.p_1,
                                    MainStyle.text_center].join(" ")}
                         onClick={() => {setListType(2);}}
                    >
                        <span>{GetLabel(appLang, 620)}</span>
                    </div>
                </div>
            </div>
            <div className={MainStyle.py_2}/>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    {listType === 1 && (
                        <PersonalSelection 
                            configData={configData} 
                            setConfigData={setConfigData} 
                            filterDataList={filterDataList} 
                            UseItem={UseItem} 
                            CopyItem={CopyItem} 
                            EditItem={EditItem} 
                            DeleteItem={DeleteItem}
                            hideModal={hideModal}
                        />
                    )}
                    {listType === 2 && (
                        <PublicSelection 
                            configData={configData} 
                            setConfigData={setConfigData} 
                            filterDataList={filterDataList} 
                            UseItem={UseItem} 
                            CopyItem={CopyItem} 
                            EditItem={EditItem} 
                            hideModal={hideModal}
                        />
                    )}                    
                </div>    
            </div>
        </div>
    );
});

const PivotCustomControl = React.memo(({...props}) => {
    const { extractConfigData,
            configData,
            setConfigData,
            filterObj,
            setFilterObj,
            filterDataList,
            refreshControl,
            actionUpdateFilter,
            actionDeleteFilter              }   = props;    
    const { showModal, hideModal            }   = useModal();
    
    useEffect(() => {},[filterObj, filterDataList]);
    
    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_sm_2}>
                <div className={MainStyle.m_3}>
                    <div className={[MainStyle.btn_vanilla,
                                    MainStyle.rounded_3, 
                                    MainStyle.border, 
                                    MainStyle.shadow_sm, 
                                    MainStyle.fs_8,
                                    MainStyle.p_1,
                                    MainStyle.text_center].join(" ")}
                         onClick={() => {
                            showModal(
                                <TemplateEdit
                                    extractConfigData={extractConfigData}
                                    configData={configData}
                                    setConfigData={setConfigData}
                                    filterObj={filterObj}
                                    setFilterObj={setFilterObj}
                                    filterDataList={filterDataList}
                                    refreshControl={refreshControl}
                                    actionUpdateFilter={actionUpdateFilter}
                                    actionDeleteFilter={actionDeleteFilter}
                                    hideModal={hideModal}
                                />
                             );
                         }}
                    >
                        <span>{GetLabel(appLang, 613)}</span>
                    </div>
                </div>
            </div>
            <div className={MainStyle.col_sm_2}>
                <div className={MainStyle.m_3}>
                    <div className={[MainStyle.btn_vanilla,
                                    MainStyle.rounded_3, 
                                    MainStyle.border, 
                                    MainStyle.shadow_sm, 
                                    MainStyle.fs_8,
                                    MainStyle.p_1,
                                    MainStyle.text_center].join(" ")}
                         onClick={() => {
                            showModal(
                                <TemplateSelection
                                    extractConfigData={extractConfigData}
                                    configData={configData}
                                    setConfigData={setConfigData}
                                    filterObj={filterObj}
                                    setFilterObj={setFilterObj}
                                    filterDataList={filterDataList}
                                    refreshControl={refreshControl}
                                    actionUpdateFilter={actionUpdateFilter}
                                    actionDeleteFilter={actionDeleteFilter}
                                    hideModal={hideModal}
                                />
                             );
                         }}
                    >
                        <span>{GetLabel(appLang, 614)}</span>
                    </div>
                </div>
            </div>        
        </div>
    );
});

const PivotTable = React.memo(({ ...props }) => {
    const { configData,
            setConfigData,
            rawData,
            filterObj,
            setFilterObj,
            filterDataList,
            refreshControl,
            actionUpdateFilter,
            actionDeleteFilter,             }   = props;
    const   pivotRef                            = useRef(null);
    const [ pivotData,  setPivotData        ]   = useState([]);

    const localizationPkgUrl = useMemo(() => {
        return cdn_lang_map[appLang] ?? cdn_lang_map.PT;
    }, [appLang]);

    const onBeforeToolbarCreated = (toolbar) => {
        // Get the current list of tabs
        const tabs = toolbar.getTabs();
        
        // Override the getTabs method to exclude Connect, Open, and Save
        toolbar.getTabs = () => {
            return tabs.filter(tab => 
                tab.id !== "wdr-tab-connect" && 
                tab.id !== "wdr-tab-open" && 
                tab.id !== "wdr-tab-save"
            );
        };
    };

    function formatPivotDataKey(data, desiredLang) {
        if (!desiredLang) {
            desiredLang = appLang;
        }
        let dataSet = [];
        let template ={
            orderName           :   [`${GetLabel(desiredLang, 600)}`], 
            schoolName          :   [`${GetLabel(desiredLang, 318)}`], 
            areaName            :   [`${GetLabel(desiredLang, 319)}`], 
            customerName        :   [`${GetLabel(desiredLang, 322)}`], 
            programName         :   [`${GetLabel(desiredLang, 321)}`], 
            className           :   [`${GetLabel(desiredLang, 564)}`], 
            dateStart           :   [`${GetLabel(desiredLang, 388)}`],
            dateEnd             :   [`${GetLabel(desiredLang, 389)}`],
            sessionOrderDesc    :   [`${GetLabel(desiredLang, 602)}`],
            AcademicAreaName    :   [`${GetLabel(desiredLang, 323)}`],
            teacherName         :   [`${GetLabel(desiredLang, 601)}`],
            questionName        :   [`${GetLabel(desiredLang, 207)}`],
            questionTypeName    :   [`${GetLabel(desiredLang, 234)}`],
            questionDesc        :   [`${GetLabel(desiredLang, 249)}`],
            answerDate          :   [`${GetLabel(desiredLang, 603)}`],
            answerText          :   [`${GetLabel(desiredLang, 604)}`],
            ObsDesc             :   [`${GetLabel(desiredLang, 376)}`],
            answerTextValue     :   [`${GetLabel(desiredLang, 605)}`],
            answerOptionValue   :   [`${GetLabel(desiredLang, 606)}`],

        };
        for(let i = 0; i < data.length; i++) {
            dataSet.push({
                [`${template.orderName}`]               : data[i].ORDER_DESC            ,
                [`${template.schoolName}`]              : data[i].SCHOOL_DESC           ,
                [`${template.areaName}`]                : data[i].AREA_DESC             ,
                [`${template.customerName}`]            : data[i].CLIENT_DESC           ,
                [`${template.programName}`]             : data[i].PROGRAM_DESC          ,
                [`${template.className}`]               : data[i].CLASS                 ,
                [`${template.dateStart}`]               : data[i].OPENING               ,
                [`${template.dateEnd}`]                 : data[i].CLOSING               ,
                [`${template.sessionOrderDesc}`]        : data[i].SESSION_ORDER         ,
                [`${template.AcademicAreaName}`]        : data[i].ACADEMIC_AREA_DESC    ,
                [`${template.teacherName}`]             : data[i].EVOLVEDS              ,
                [`${template.questionName}`]            : data[i].QUESTION_DESC         ,
                [`${template.questionTypeName}`]        : data[i].QUESTION_TYPE_DESC    ,
                [`${template.questionDesc}`]            : data[i].QUESTION_LBL_DESC     ,
                [`${template.answerDate}`]              : data[i].SUBMISSION_DT         ,
                [`${template.answerText}`]              : data[i].ANSWER_VALUE          ,
                [`${template.ObsDesc}`]                 : data[i].OBSERVATION           ,
                [`${template.answerTextValue}`]         : data[i].OPT                   ,
                [`${template.answerOptionValue}`]       : data[i].OPTION_VALUE          ,
            });
        }
        return (dataSet);
    }

    async function extractConfigData(){
        const instance = pivotRef.current?.webdatarocks;
        if (!instance) return;

        try {
            const fullReport = instance.getReport();
            const currentSlice = fullReport.slice;            
            return currentSlice;
        } 
        catch (error) {
            console.error("Failed to extract report:", error);
        } 
    };

    useEffect(() => {
        if (Array.isArray(rawData) && rawData.length > 0) {
            const parsedData = formatPivotDataKey(rawData, appLang);
            setPivotData(parsedData);
        }
    }, [rawData]);

    useEffect(() => {
        const instance = pivotRef.current?.webdatarocks;
        // Safe guard
        if (!instance || !pivotData || pivotData.length === 0 || !configData) return;

        try {
            const currentSlice = configData[appLang] || configData.PT || configData;
            
            // Safe guard
            if (typeof currentSlice !== 'object') return;

            instance.setReport({
                dataSource: { data: pivotData },
                slice: currentSlice,
                localization: localizationPkgUrl 
            });
        } catch (error) {
            console.error("Error updating pivot report:", error);
        }
    }, [pivotData, configData, filterObj]);
    
    //avoid mounting with empty/null data
    if (!Array.isArray(rawData) || rawData.length === 0) {
        return (
            <div className={[ MainStyle.align_self_center, MainStyle.m_3].join(" ")}>
                <span className={[MainStyle.mx_3, MainStyle.text_body, MainStyle.fs_7].join(" ")}>
                    {GetLabel(appLang, 548)}
                </span> 
            </div>
        ); 
    }

    return (
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.rounded].join(" ")}>
            <PivotCustomControl 
                extractConfigData={extractConfigData}
                configData={configData}
                setConfigData={setConfigData}
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                filterDataList={filterDataList}
                refreshControl={refreshControl}
                actionUpdateFilter={actionUpdateFilter}
                actionDeleteFilter={actionDeleteFilter}
            />
            <div
                style={{
                    width: "100%",
                    height: "600px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <div
                    style={{
                        flex: 1,
                        minHeight: 0,
                        overflow: "auto"
                    }}
                >
                    <WebDataRocksReact.Pivot
                        ref={pivotRef}
                        toolbar={true}
                        width="100%"
                        height="800"
                        report={{
                            dataSource: { data: pivotData },
                            localization: localizationPkgUrl
                        }}
                        beforetoolbarcreated={onBeforeToolbarCreated}
                    />
                </div>
            </div>
        </div>
    );

});

export default PivotTable;